module.exports = __webpack_public_path__ + "media/images/Calendar-0391b3f9.png";